"use client";

import clsx from "clsx";
import CustomIcon from "@/components/ui/custom-icon";
import { useMedia } from "@/hooks/system/useMedia";
import S from "../../index.module.scss";

export interface VariantOptionViewItem {
  key: number;
  title: string;
  colour: string | null;
}

interface VariantOptionBaseViewProps {
  title: string;
  items: VariantOptionViewItem[];
  selectedKey?: number;
  onSelect: (key: number) => void;
}

const VariantOptionBaseView = ({ title, items, selectedKey, onSelect }: VariantOptionBaseViewProps) => {
  const { isMobile, isClient } = useMedia();
  const isColorGroup = items.some(item => item.colour !== null);
  const selectedItem = items.find(item => item.key === selectedKey);

  return (
    <div className={S.optionGroup}>
      <p className={S.optionTitle}>{title}</p>
      {isColorGroup ? (
        <div className={S.swatchesWrapper}>
          <div className={S.swatches}>
            {items.map(item => {
              const isSelected = selectedKey === item.key;

              return (
                <button
                  key={`${item.key}${item.title}`}
                  type="button"
                  className={S.swatchButton}
                  onClick={() => onSelect(item.key)}
                  aria-label={item.title}
                  aria-pressed={isSelected}
                >
                  <span
                    className={clsx(S.swatch, isSelected && S.swatchSelected)}
                    style={{ backgroundColor: item.colour ?? "transparent" }}
                  >
                    {isSelected && (
                      <span className={S.swatchCheck}>
                        <CustomIcon fileName="icon-check-config" />
                      </span>
                    )}
                  </span>
                  {!isMobile && isClient && <span className={S.swatchLabel}>{item.title}</span>}
                </button>
              );
            })}
          </div>
          {isMobile && isClient && <span className={S.swatchLabel}>{selectedItem?.title}</span>}
        </div>
      ) : (
        <div className={S.sizeOptions}>
          {items.map(item => {
            const isSelected = selectedKey === item.key;

            return (
              <button
                key={`${item.key}${item.title}`}
                type="button"
                className={clsx(S.sizeButton, isSelected && S.sizeButtonSelected)}
                onClick={() => onSelect(item.key)}
                aria-pressed={isSelected}
              >
                {isSelected && <CustomIcon fileName="icon-check-config" />}
                {item.title}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default VariantOptionBaseView;
